import { Navigate, useLocation } from 'react-router-dom'
import type { ReactNode } from 'react'
import { useAuth } from '@/contexts/AuthContext'
import { Spinner } from '@/components/ui/spinner'

function FullScreenSpinner() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <Spinner className="size-8 text-primary" />
    </div>
  )
}

/**
 * Guards guild routes: requires a signed-in user, and (unless the route IS
 * onboarding) a guild profile. Users without a profile are sent to onboarding.
 */
export default function ProtectedRoute({
  children,
  requireProfile = true,
}: {
  children: ReactNode
  requireProfile?: boolean
}) {
  const { user, guildProfile, initializing, profileLoaded } = useAuth()
  const location = useLocation()

  if (initializing || (user && !profileLoaded)) {
    return <FullScreenSpinner />
  }

  if (!user) {
    return <Navigate to="/auth" state={{ from: location }} replace />
  }

  if (requireProfile && !guildProfile) {
    return <Navigate to="/onboarding" replace />
  }

  if (!requireProfile && guildProfile) {
    // Already a member — onboarding is done
    return <Navigate to="/dashboard" replace />
  }

  return <>{children}</>
}
